import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b9c8445"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task-files" }
const _hoisted_2 = { class: "task-files__header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "task-files__label" }, "Файлы")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "task-files__label" }, "Файлы", -1))
const _hoisted_5 = { class: "task-files__files" }

import { computed, PropType } from 'vue';
import {
  TirPmFileUploader,
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmScrollbar,
} from 'tir-components';
import { TaskFileModel } from '../../models';
import { PaperClipIcon } from 'tir-style-system/icons/outline';
import { PreviewFileModel } from './models';
import { FilePreviewAccessEnum, TirPmFilePreview } from 'tir-pm-file-preview';


export default /*#__PURE__*/_defineComponent({
  __name: 'task-files',
  props: {
  /**Список файлов */
  files: {
    type: Array as PropType<Array<TaskFileModel>>,
    default: [],
  },
  /**Заблокировать создание файлов */
  isDisabled: {
    type: Boolean,
    default: false,
  },
  /**Загрузка кнопки прикрепления*/
  isLoadingAttachButton: {
    type: Boolean,
    default: false,
  },
  /**Загрузка при редактировании названия */
  filesLoadingEditName: {
    type: Array as PropType<Array<number>>,
    default: [],
  },
},
  emits: ["attachFiles", "removeFile", "updateName", "openEditImage"],
  setup(__props, { emit }) {

const props = __props;



const emitUpdateName = (fileId: number, fileName: string) => emit('updateName', fileId, fileName);



const filesToPreview = computed(() => {
  const files = new Array<PreviewFileModel>();

  files.push(
    ...props.files.map((file) => {
      return new PreviewFileModel({
        FileId: file.Id,
        Url: file.Url,
        Name: file.Name,
        Size: file.Size,
        DateUpload: file.DateUpload,
        User: {
          Id: file.User.Id,
          FirstName: file.User.FirstName,
          LastName: file.User.LastName,
          MiddleName: file.User.MiddleName,
          AvatarColor: file.User.AvatarColor,
          Image: file.User.ImageUrl,
        },
        Progress: file.UploadProgress,
        IsProccessing: file.IsProccessing,
        VideoPreviewUrl: file.VideoPreviewUrl,
        Accesses:
          props.isDisabled || file.IsSendingLastChunk
            ? []
            : [FilePreviewAccessEnum.Edit, FilePreviewAccessEnum.Remove],
      });
    }),
  );

  return files.sort((a, b) => b.DateUpload.getTime() - a.DateUpload.getTime());
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!__props.files.length)
        ? (_openBlock(), _createBlock(_unref(TirPmFileUploader), {
            key: 0,
            "is-disabled": __props.isDisabled,
            "is-multiple": "",
            onUploadFiles: _cache[0] || (_cache[0] = ($event: any) => (emit('attachFiles', $event)))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(['task-files__header-row-empty', { 'is-disabled': __props.isDisabled }])
              }, [
                _hoisted_3,
                _createElementVNode("div", null, [
                  _createVNode(_unref(TirPmButton), {
                    size: _unref(TirPmButtonSizeEnum).Small,
                    variant: _unref(TirPmButtonVariantEnum).SecondaryState,
                    "is-loading": __props.isLoadingAttachButton,
                    "is-disabled": __props.isDisabled
                  }, {
                    leftSlot: _withCtx(() => [
                      _createVNode(_unref(PaperClipIcon))
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" Выберите файл ")
                    ]),
                    _: 1
                  }, 8, ["size", "variant", "is-loading", "is-disabled"])
                ])
              ], 2)
            ]),
            _: 1
          }, 8, ["is-disabled"]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_4,
            _createVNode(_unref(TirPmFileUploader), {
              "is-disabled": __props.isDisabled,
              "is-multiple": "",
              "max-size": 10000 * 1024 * 1024,
              onUploadFiles: _cache[1] || (_cache[1] = ($event: any) => (emit('attachFiles', $event)))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(TirPmButton), {
                  size: _unref(TirPmButtonSizeEnum).Small,
                  variant: _unref(TirPmButtonVariantEnum).SecondaryState,
                  "is-disabled": __props.isDisabled
                }, {
                  leftSlot: _withCtx(() => [
                    _createVNode(_unref(PaperClipIcon))
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" Выберите файл ")
                  ]),
                  _: 1
                }, 8, ["size", "variant", "is-disabled"])
              ]),
              _: 1
            }, 8, ["is-disabled"])
          ], 64))
    ]),
    _createVNode(_unref(TirPmScrollbar), {
      class: "task-files__scrollbar",
      "enable-drag-scroll": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filesToPreview.value, (file) => {
            return (_openBlock(), _createBlock(_unref(TirPmFilePreview), {
              class: "task-files__file-preview",
              file: file,
              files: filesToPreview.value,
              "files-loading-edit-name": __props.filesLoadingEditName,
              key: file.FileId,
              onOnClickDelete: ($event: any) => (emit('removeFile', file.FileId)),
              onOnClickEdit: _cache[2] || (_cache[2] = ($event: any) => (emit('openEditImage', $event))),
              onSaveName: emitUpdateName
            }, null, 8, ["file", "files", "files-loading-edit-name", "onOnClickDelete"]))
          }), 128))
        ])
      ]),
      _: 1
    })
  ]))
}
}

})